import React, { useRef, useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const PageWrapper = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #112e16;
  color: #ffffff;
`;

const Container = styled.div`
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 40px;
  padding: 20px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    text-align: center;
  }
`;

const LeftSection = styled(motion.div)``;

const Title = styled.h1`
  font-size: 56px;
  line-height: 1.2;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 38px;
  }
`;

const Highlight = styled.span`
  font-size: 26px;
  background: #ceb766;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Description = styled.p`
  font-size: 18px;
  color: #cccccc;
  margin-bottom: 30px;
  line-height: 1.6;
`;

const Button = styled.a`
  display: inline-block;
  padding: 14px 28px;
  border-radius: 30px;
  font-weight: 600;
  text-decoration: none;
  background: #ceb766;
  color: #000;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 10px 25px rgba(255, 215, 0, 0.3);
  }
`;

const RightSection = styled(motion.div)`
  position: relative;
`;

const VideoWrapper = styled.div`
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
`;

const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const SoundButton = styled.button`
  position: absolute;
  bottom: 15px;
  left: 15px;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);
  padding: 8px 14px;
  border-radius: 12px;
  font-size: 14px;
  border: none;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
`;

export default function ComingSoonPage() {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  const toggleSound = () => {
    if (videoRef.current) {
      const newMutedState = !isMuted;
      videoRef.current.muted = newMutedState;
      videoRef.current.play();
      setIsMuted(newMutedState);
    }
  };

  return (
    <PageWrapper>
      <Container>
        {/* RIGHT SIDE */}
        <RightSection
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <VideoWrapper>
            <Video
              ref={videoRef}
              src="/assets/AI.mp4"
              autoPlay
              muted
              loop
              playsInline
            />
          </VideoWrapper>

          <SoundButton onClick={toggleSound}>
            {!isMuted ? "🔇 Mute" : "🔊 Sound On"}
          </SoundButton>
        </RightSection>

        {/* LEFT SIDE */}
        <LeftSection
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Title>
            <div style={{ fontSize: "32px" }}>Our new beginning</div>

            <div
              style={{
                letterSpacing: "3px",
                color: "#CEB766",
              }}
            >
              House of Dhaare
            </div>

            <div style={{ fontSize: "22px" }}>Where tradition flows</div>

            <Highlight>Something beautiful is arriving</Highlight>
          </Title>

          <Description>
            We are launching a premium collection of traditional sarees crafted
            with elegance, heritage, and modern style.
          </Description>

          <Button
            href="https://www.instagram.com/houseofdhaare/"
            target="_blank"
          >
            Follow us on Instagram
          </Button>
        </LeftSection>
      </Container>
    </PageWrapper>
  );
}
